import ListSelect from 'common/components/selectors/ListSelect';

const PortTypeSelector = ({ isMulti, filter, value, label, onChange }) => {
  return (
    <ListSelect
      list="port-types"
      label={label}
      placeholder={'Select value'}
      getOptionValue={option => option.id}
      getOptionLabel={option => option.name}
      onChange={selected => {
        onChange({
          data: selected ? selected : [],
          value: selected ? (isMulti ? selected : selected) : ''
        });
      }}
      value={filter ? (filter.value && Array.isArray(filter.value) ? filter.value : []) : value}
      isMulti
      isClearable
    />
  );
};

export default PortTypeSelector;
